class InterceptorManagerImpl {
    use(interceptor) {
        const id = this.nextId++;
        this.interceptors[id] = interceptor;
        return id;
    }
    eject(id) {
        delete this.interceptors[id];
    }
    clear() {
        this.interceptors = [];
    }
    getInterceptors() {
        return this.interceptors.filter(Boolean);
    }
    getRequestInterceptors() {
        return this.interceptors.filter((interceptor)=>interceptor && 'onRequest' in interceptor);
    }
    getResponseInterceptors() {
        return this.interceptors.filter((interceptor)=>interceptor && 'onResponse' in interceptor);
    }
    constructor(){
        this.interceptors = [];
        this.nextId = 0;
    }
}
const createRetryInterceptor = (maxRetries = 3, retryDelay = 1000)=>({
        onResponse: (response)=>response,
        onResponseError: async (error)=>{
            const config = error.config;
            const currentRetries = config.__retryCount || 0;
            if (currentRetries < maxRetries && (!error.response?.status || error.response?.status >= 500)) {
                config.__retryCount = currentRetries + 1;
                await new Promise((resolve)=>setTimeout(resolve, retryDelay * Math.pow(2, currentRetries)));
                throw new Error('RETRY_REQUEST');
            }
            return error;
        }
    });
const createTimeoutInterceptor = (timeout)=>({
        onRequest: (config)=>({
                ...config,
                timeout: config.timeout || timeout
            })
    });
export { InterceptorManagerImpl, createRetryInterceptor, createTimeoutInterceptor };
